import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Building2, Users, MessagesSquare, Phone, DollarSign } from "lucide-react";

const KpiCard = ({ Icon, label, value }) => (
  <div className="hs-card p-5">
    <div className="flex items-center justify-between">
      <div className="text-[11px] font-mono uppercase text-[#4B5563]">{label}</div>
      <Icon className="w-4 h-4 text-[#4B5563]" />
    </div>
    <div className="font-display font-extrabold text-4xl mt-3">{value}</div>
  </div>
);

export default function AdminOverview() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/analytics/admin/overview").then((r) => setData(r.data)); }, []);
  if (!data) return <div className="text-sm text-[#4B5563]">Loading…</div>;

  return (
    <div data-testid="admin-overview-page" className="space-y-6">
      <div>
        <h1 className="font-display font-extrabold text-3xl">Platform overview</h1>
        <p className="text-sm text-[#4B5563]">Vendors, users, revenue and conversation volume.</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        <KpiCard Icon={Building2} label="Tenants" value={data.kpis.tenants} />
        <KpiCard Icon={Users} label="Users" value={data.kpis.users} />
        <KpiCard Icon={MessagesSquare} label="Conversations" value={data.kpis.conversations} />
        <KpiCard Icon={Phone} label="Calls" value={data.kpis.calls} />
        <KpiCard Icon={DollarSign} label="Revenue" value={`$${data.kpis.revenue_usd}`} />
      </div>

      <div className="hs-card p-6">
        <div className="font-display font-bold mb-3">Industry breakdown</div>
        {data.industry_breakdown.length === 0 ? (
          <div className="text-sm text-[#4B5563]">No vendors with industry set yet.</div>
        ) : (
          <div className="space-y-2">
            {data.industry_breakdown.map((row) => (
              <div key={row.industry} className="flex items-center justify-between text-sm border-b border-[#E2E8F0] py-2">
                <span className="font-medium capitalize">{row.industry}</span>
                <span className="font-mono">{row.count}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
